import React from "react";
import { CheckBoxProps } from "./types";
import styles from "./CheckBox.module.scss";

export const CheckBox: React.FC<CheckBoxProps> = ({ id, lable, checked, onChange }) => {
  return (
    <div className={styles.checkboxWrapper}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className={styles.checkbox}
      />
      <label htmlFor={id} className={styles.label}>
        {lable}
      </label>
    </div>
  )
}